import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValueChangeEvent } from '@interfaces/form.interface';

@Component({
  selector: 'ark-ui-toggle',
  templateUrl: './ui-toggle.component.html',
  styleUrls: ['./ui-toggle.component.scss'],
})
export class UiToggleComponent {
  @Input() id!: string;
  @Input() text!: string;

  @Input() checked: boolean = false;

  @Output() selectionChanged = new EventEmitter<ValueChangeEvent>();
  constructor() {}

  toggle() {
    this.checked = !this.checked;

    this.selectionChanged.emit({ status: 'VALID', value: this.checked });
  }
}
